// extracted by mini-css-extract-plugin
export default {"popconfirm":"styles_popconfirm__79yBu","button":"styles_button__bXsCD","ant-btn-disabled":"styles_ant-btn-disabled__Eb726","custom-button":"styles_custom-button__iTwWs"};